export default class GeoWidgetConfigDataModel {
  /**
   * @var {number}
   */
  index;

  /**
   * @var {string}
   */
  metric;

  /**
   * @var {number}
   */
  value;

  /**
   * @var {number}
   */
  rawValue;

  /**
   * @var  {Array<SliceWidgetConfigDataModel>}
   */
  subs;

  /**
   * @var {number}
   */
  percent;

  /**
   * @var {boolean}
   */
  isOther;

  /**
   * @var {boolean}
   */
  isMetric;

  /**
   * @var {string}
   */
  rawMetric;

  /**
   * @var {string}
   */
  dataFormat;

  /**
   * @var {string}
   */
  isClicked;

  constructor(model = {}) {
    this.id = model.mapconfig.geocode0?.toUpperCase();
    this.latitude = model.mapconfig.geo_latitude;
    this.longitude = model.mapconfig.geo_longitude;
    this.index = model.index;
    this.metric = model.metric;
    this.value = model.value ?? 0;
    this.rawValue = model.rawValue ?? 0;
    this.subs = model.subs ?? [];
    this.percent = model.percent ?? 0;
    this.isOther = model.isOther ?? false;
    this.isMetric = true;
    this.rawMetric = model.rawMetric;
    this.dataFormat = model.dataFormat;
    this.isClicked = false;
  }
}
